// Internal modules
import { appStore } from '@/store';
import { getFieldError } from '@/lib';
import { isFunction } from '@/lib/utils/typeUtils';
import { maskingFunctionMap } from '../IdentityDocumentNumber/utils';
import { validationFunctionMap } from '../IdentityDocumentNumber/validation';

const updateIdentityDocumentNumber = type => {
  const { form: formState } = appStore.getState();
  const { form: formAction } = appStore.getActions();
  const { identityDocumentNumber } = formState;
  const { updateNonAddressField } = formAction;

  // demask if masking function is missing
  const hasMaskingFunction = isFunction(maskingFunctionMap[type]);
  const value = hasMaskingFunction
    ? maskingFunctionMap[type](identityDocumentNumber.value)
    : maskingFunctionMap.DEMASK(identityDocumentNumber.value);

  // reset errors if validation function is missing
  const hasValidationFunction = isFunction(validationFunctionMap[type]);
  const validation = hasValidationFunction
    ? validationFunctionMap[type](value)
    : validationFunctionMap.DEFAULT(value);

  const payload = getFieldPayload(value, validation);

  updateNonAddressField({
    field: 'identityDocumentNumber',
    payload,
  });
};

const getFieldPayload = (value, validation) => {
  const { errors = [], isValid } = validation;
  const errorCode = errors[0] || '';
  const error = getFieldError({
    errorCode,
    field: 'identityDocumentNumber',
    isValid,
    value,
  });

  return {
    error,
    errorCode,
    isValid,
    value,
    ...(isValid && { displayError: !isValid }),
  };
};

export { updateIdentityDocumentNumber };
